import _regeneratorRuntime from 'babel-runtime/regenerator';
import { call, select, take, fork } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import Backoff from 'backo2';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(backoffRetry),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(waitForState),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(safe);

function backoffRetry(min, max, saga) {
	for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		args[_key - 3] = arguments[_key];
	}

	var backoff, result;
	return _regeneratorRuntime.wrap(function backoffRetry$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					backoff = new Backoff({
						min: min,
						max: max
					});

				case 1:
					_context.prev = 1;
					_context.next = 4;
					return call.apply(undefined, [saga].concat(args));

				case 4:
					result = _context.sent;
					return _context.abrupt('return', result);

				case 8:
					_context.prev = 8;
					_context.t0 = _context['catch'](1);
					_context.next = 12;
					return call(delay, backoff.duration());

				case 12:
					_context.next = 1;
					break;

				case 14:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked, this, [[1, 8]]);
}

function waitForState(selector) {
	for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		args[_key2 - 1] = arguments[_key2];
	}

	var state;
	return _regeneratorRuntime.wrap(function waitForState$(_context2) {
		while (1) {
			switch (_context2.prev = _context2.next) {
				case 0:
					_context2.next = 2;
					return select.apply(undefined, [selector].concat(args));

				case 2:
					state = _context2.sent;

					if (!(typeof state !== 'undefined')) {
						_context2.next = 5;
						break;
					}

					return _context2.abrupt('return', state);

				case 5:
					_context2.next = 7;
					return take('*');

				case 7:
					{
						_context2.next = 0;
						break;
					}

				case 8:
				case 'end':
					return _context2.stop();
			}
		}
	}, _marked2, this);
}

function safe(saga) {
	var _len3,
	    args,
	    _key3,
	    _args3 = arguments;

	return _regeneratorRuntime.wrap(function safe$(_context3) {
		while (1) {
			switch (_context3.prev = _context3.next) {
				case 0:
					_context3.prev = 0;

					for (_len3 = _args3.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
						args[_key3 - 1] = _args3[_key3];
					}

					_context3.next = 4;
					return call.apply(undefined, [saga].concat(args));

				case 4:
					return _context3.abrupt('return', _context3.sent);

				case 7:
					_context3.prev = 7;
					_context3.t0 = _context3['catch'](0);
					return _context3.abrupt('return', null);

				case 10:
				case 'end':
					return _context3.stop();
			}
		}
	}, _marked3, this, [[0, 7]]);
}
var _safe = function _safe(effect) {
	return fork( /*#__PURE__*/_regeneratorRuntime.mark(function safeRunner() {
		return _regeneratorRuntime.wrap(function safeRunner$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.prev = 0;
						_context4.next = 3;
						return effect;

					case 3:
						return _context4.abrupt('return', _context4.sent);

					case 6:
						_context4.prev = 6;
						_context4.t0 = _context4['catch'](0);
						return _context4.abrupt('return', null);

					case 9:
					case 'end':
						return _context4.stop();
				}
			}
		}, safeRunner, this, [[0, 6]]);
	}));
};

export { backoffRetry, waitForState, safe, _safe };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@livechat/saga-utils/dist/saga-utils.esm.js
// module id = 554
// module chunks = 0